export default __webpack_public_path__ + "static/media/up-arrow-svgrepo-com.86b10dc6.svg";